// composables/useFormMessages.ts
// Переиспользуемый composable для управления сообщениями формы

export const useFormMessages = () => {
  const errorMessage = ref<string | null>(null)
  const successMessage = ref<string | null>(null)
  const loader = ref(false)
  
  /**
   * Очистить все сообщения
   */
  const clearMessages = () => {
    errorMessage.value = null
    successMessage.value = null
  }
  
  /**
   * Очистить сообщения с задержкой
   */
  const clearMessagesAfterDelay = (delay = 6000) => {
    setTimeout(clearMessages, delay)
  }
  
  /**
   * Установить сообщение об ошибке
   */
  const setErrorMessage = (message: string, autoClear = true) => {
    errorMessage.value = message
    if (autoClear) {
      clearMessagesAfterDelay()
    }
  }
  
  /**
   * Установить сообщение об успехе
   */
  const setSuccessMessage = (message: string, autoClear = true) => {
    successMessage.value = message
    if (autoClear) {
      clearMessagesAfterDelay()
    }
  }
  
  /**
   * Начать загрузку
   */
  const startLoading = () => {
    loader.value = true
    clearMessages()
  }
  
  /**
   * Остановить загрузку
   */
  const stopLoading = () => {
    loader.value = false
  }
  
  /**
   * Обработать успешный ответ
   */
  const handleSuccess = (message: string, callback?: () => void, delay = 2000) => {
    setSuccessMessage(message)
    if (callback) {
      setTimeout(callback, delay)
    }
  }
  
  /**
   * Обработать ошибку
   */
  const handleError = (error: any) => {
    const message = error?.data?.message || error?.message || 'Произошла ошибка'
    setErrorMessage(message)
  }
  
  return {
    // State
    errorMessage,
    successMessage,
    loader,
    
    // Methods
    clearMessages,
    clearMessagesAfterDelay,
    setErrorMessage,
    setSuccessMessage,
    startLoading,
    stopLoading,
    handleSuccess,
    handleError,
  }
}

